import { render } from "./App.vue?vue&type=template&id=3622253c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3622253c&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__